import { Loader, MultiSelect, type MultiSelectProps } from '@mantine/core';
import { useGetActivitySphere } from '../../api';
import { filterActivitySpheres } from '../../lib/filterActivitySpheres';
import { formatActivitySphereLabel } from '../../lib/formatActivitySphereLabel';
import { IconSelector } from '@tabler/icons-react';
import classes from './activity-sphere-multiselect.module.scss';

export const ActivitySphereMultiselect = (props: MultiSelectProps) => {
  const { data: activitySpheres, isLoading: isActivitySpheresLoading } =
    useGetActivitySphere();

  const activitySpheresOptions = activitySpheres?.map(({ id, name, code }) => ({
    value: id.toString(),
    label: formatActivitySphereLabel({ code, name }),
  }));

  const displayValue =
    props.value === undefined
      ? undefined
      : isActivitySpheresLoading
        ? []
        : props.value;
  const displayPlaceholder =
    isActivitySpheresLoading || (props.value && props.value.length > 0)
      ? ''
      : props.placeholder;

  return (
    <MultiSelect
      searchable
      filter={filterActivitySpheres}
      nothingFoundMessage='Ничего не найдено'
      classNames={classes}
      {...props}
      value={displayValue}
      placeholder={displayPlaceholder}
      data={activitySpheresOptions}
      rightSection={
        isActivitySpheresLoading ? (
          <Loader size='xs' aria-label='Загрузка сфер деятельности' />
        ) : (
          <IconSelector size={20} color='var(--mantine-color-primary-7)' />
        )
      }
      disabled={isActivitySpheresLoading || props.disabled}
    />
  );
};
